import type { FaireProductEntity } from "../../entity_types/product";

export const p_hphj4xjpks: FaireProductEntity = {
  token: "p_hphj4xjpks",
  type: "product",
  name: "Luxury Organic Therapeutic Bath Bombs 56 x 130g",
  brandToken: "b_zm63ypwage",
  brandName: "Organic Essentials",
  imageUrl:
    "https://cdn.faire.com/fastly/543ff10875ac90ed925c4042576c9008f1db729119c979cacae22ee115d26a71.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/06cd7419805a09dd485661b3af687dc397ecd0cc1272b95b1f8805b67e56ac40.png",
    "https://cdn.faire.com/fastly/9e09965e374e3b6c90d51bcc78c35f1d7c47c5583c1186da98b0010ec3667791.png",
    "https://cdn.faire.com/fastly/8079c310d0feb1b4b0a10c6f942b76517d3cb6f3aba0533763baf7cea0126186.png",
    "https://cdn.faire.com/fastly/a09fcc9f20bdf60b553203c5a7a60a6c1b89ae7bcfe2aea76cde0143d3aa7c8f.jpeg",
  ],
  priceDollars: 216.54,
  description:
    "All our ingredients have wonderful therapeutic and relaxing qualities : Great for pain relief, good remedy for colds, calms emotions and allows for deep rest.\n\nWe only use the finest natural/organic ethically sourced ingredients which are palm oil free, cruelty free and all are packaging is fully recyclable and bio-degradable and full of organic goodness. \n\nYou will receive 7 of each of our eight therapeutic variations. \nLavender & Neroli\nPalmarosa & Rose\nMandarin & Cedarwood\nYlang Ylang & Lemongrass\nOrganic Coconut & Bergamot\nPine Needle & Thyme\nTea Tree & Sicilian Lemon\nRosemary & Peppermint\n\nOur bath bombs have been assessed by Cosmetic Safety Consultants and have passed with Cosmetic Safety Product Report (CSPR).\n\nEach bath bomb is 130g and wrapped in eco-friendly tissue paper. \n\nWith your order we provide a flyer which includes our story, ingredients, warnings, how to use and images of the bath bombs.\n\nRelax, replenish, revitalize and enjoy!\n\nMaya",
  tags: [],
  msrpDollars: 433.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:15.110Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
